import React, { useEffect } from "react";
import "../static/artistReview.css";
import { CarouselWrapper } from "./react-pretty-carousel-master/src";
import kairavi from "../static/images/kairavi.jpg";
import kaushalbros from "../static/images/kaushalbros.jpg";
import akansha from "../static/images/akansha (1).jpg";

function ArtistReview() {
  const page = (e) => {
    let carousel = document.querySelector(".carousel");
    let children = document.querySelectorAll(".index");
    console.log(e.target);
    if (children) {
      const index = Array.from(children).indexOf(e.target);
      carousel.scrollTo(index * carousel.clientWidth, 0);
    }
  };
  useEffect(() => {
    let carousel = document.querySelector(".carousel");
    let children = document.querySelectorAll(".index");
    carousel.addEventListener("scroll", (e) => {
      let page = Math.ceil((carousel.scrollLeft + 20) / carousel.clientWidth);
      children.forEach((e) => {
        e.classList.remove("active1");
      });
      if (page <= 0) {
        children.item(0).classList.add("active1");
      } else children.item(page - 1).classList.add("active1");
    });
  }, []);
  return (
    <div className="d-flex flex-column justify-content-center align-items-center reviewContainer ">
      <div className="font-white col-xl-7 col-lg-7 col-md-7 col-sm-10 col-10 text-center pl-xl-6 pl-lg-6 pl-md-6 mx-auto mt-sm-5 mt-5 mb-sm-3 mb-3 reviewTitle curatedHeading">
        Artists love Ombré
      </div>
      <div className="reviewDetails col-xl-8 col-lg-8 col-md-8 col-sm-10 col-10 mx-auto mb-sm-5 mb-5 text-center curatedDescription mt-xl-4 mt-lg-4 mt-md-4 mt-sm-3 mt-3">
        Imagine a place where artists thrive and grow by helping each other. A
        place where artists feel at home. That place is Ombré !
      </div>
      <div className="reviewCommentCard mx-auto">
        <div className="d-flex flex-column align-items-center justify-content-center reviewInnerContainer">
          <div className="apostrophy"></div>

          <div className="carousel ">
            <div className="slide font-white align-items-center justify-content-center">
              <div className="reviewComment ">
                “ An organised way to conduct a fun session where you already
                know what to sing because of the song suggestions given under
                the fan request section. Thrilled to use this app. ”
              </div>
              <div className="reviewer mt-xl-3 mt-lg-3 mt-md-3 mb-2">
                Kaira Virane
              </div>
              <div className="reviewerDetails mb-xl-4 mb-lg-4 mb-md-4 mb-sm-3 mb-3">
                Singer, Guitarist, Vocals{" "}
              </div>
              <img src={kairavi} className="artistReviewImage "></img>
            </div>
            <div className="slide font-white align-items-center justify-content-center ">
              <div className="reviewComment">
                “ Great platform for musicians to live stream and reach the
                right target audience. With various monetization options on the
                app, upcoming Folk artists can also begin earning early on in
                their careers. ”
              </div>
              <div className="reviewer mt-xl-3 mt-lg-3 mt-md-3 mb-2">
                Kaushal brothers
              </div>
              <div className="reviewerDetails mb-xl-4 mb-lg-4 mb-md-4 mb-sm-3 mb-3">
                Singers, Composers and Live Performers
              </div>
              <img src={kaushalbros} className="artistReviewImage "></img>
            </div>
            <div className="slide font-white align-items-center justify-content-center ">
              <div className="reviewComment">
                “ Ombré, as the name suggests, means "bringing together
                different shades" and that is what this wonderful platform has
                been doing. It has brought together all kinds of artists on a
                unified stage where they can be more respected. ”
              </div>
              <div className="reviewer mt-xl-3 mt-lg-3 mt-md-3 mb-2">
                Akanksha
              </div>
              <div className="reviewerDetails mb-xl-4 mb-lg-4 mb-md-4 mb-sm-3 mb-3">
                Singer, Guitarist, Vocals{" "}
              </div>
              <img src={akansha} className="artistReviewImage "></img>
            </div>
          </div>
          <div className="pagination position-absolute">
            <button className="index active1" onClick={(e) => page(e)}></button>
            <button className="index" onClick={(e) => page(e)}></button>
            <button className="index" onClick={(e) => page(e)}></button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ArtistReview;



// WEBPACK FOOTER //
// ./src/pages/Artist/components/ArtistReview.jsx